import { StoreViewModel } from '@models/api.models';

export const findStoreById = (stores: StoreViewModel[], id: number | string): StoreViewModel | undefined => {
    if (!stores.length || !id) {
        return;
    }
    return stores.find(store => store.storeId === (typeof id === 'string' ? parseInt(id, 10) : id));
};
